import {
  TerminPreviazaneTerminyUpdateApi,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import PreviazaneTerminy from '../../model/PreviazaneTerminy';

const client = new TerminPreviazaneTerminyUpdateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const updateTerminPreviazaneTerminy = async (
  terminUuid: Uuid,
  previazaneTerminyUpdate: PreviazaneTerminy,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const previazanyTerminListUpdateObject = {
    previazanyTerminList: previazaneTerminyUpdate,
  };

  const {
    status,
    // @ts-ignore
  } = await client.updateTerminPreviazaneTerminy(terminUuid, previazanyTerminListUpdateObject, options);

  return {
    responseCode: status,
  };
};
